<template>
  <div class="header">
    <!-- 头像 -->
    <div class="avator">
      <div class="icon" id="container">
        <img :src="icon" class="avatar" id="pickfiles">
      </div>

    </div>

    <div class="content">
      <!-- 设置 -->
      <router-link to="/record/setting">
        <div class="setting"></div>
      </router-link>

      <div class="heart">

      </div>

      <div class="name" v-text="name">
      </div>

      <div class="other" v-text="other">
      </div>
    </div>


  </div>
</template>

<script type="text/ecmascript-6">
  import Qiniu from 'Qiniu';
  import plupload from 'plupload';
  import PostMsg from '../api/postmsg';
  import netTool from '../api/netTool';
  import { Indicator } from 'mint-ui';
  import { mapGetters } from 'vuex';

  export default{
    name: 'headerPeople',
    created () {
      // this.qiniuInitToken();
    },
    data () {
      return {
        uploader: '',
        uptoken: '',
        inputId: ''
      };
    },
    computed: {
      ...mapGetters({
        user: 'getUserInfo'
      }),
      icon () {
        return this.user.avatar;
      },
      name () {
        return this.user.userName;
      },
      other () {
        // if (this.user.roleId !== 7) {
          return this.user.roleName;
        // } else {
        //   return this.user.roleName;
        // }
      }
    },
    watch:{
      // 'user':{
      //   handler(newVal,oldVal){
      //     console.log(newVal)
      //   }
      // }
    },
    methods: {
      clickSet () {
        this.router.push();
      },

//       qiniuInit () {
//         var _self = this;
//         this.upLoader = Qiniu.uploader({
//           runtimes: 'html5,flash,html4',      // 上传模式，依次退化
//           browse_button: 'pickfiles',         // 上传选择的点选按钮，必需
//           // 在初始化时，uptoken，uptoken_url，uptoken_func三个参数中必须有一个被设置
//           // 切如果提供了多个，其优先级为uptoken > uptoken_url > uptoken_func
//           // 其中uptoken是直接提供上传凭证，uptoken_url是提供了获取上传凭证的地址，如果需要定制获取uptoken的过程则可以设置uptoken_func
//           uptoken: this.uptoken, // uptoken是上传凭证，由其他程序生成
//           // uptoken_url: '/uptoken',         // Ajax请求uptoken的Url，强烈建议设置（服务端提供）
//           // uptoken_func: function(file){    // 在需要获取uptoken时，该方法会被调用
//           //    // do something
//           //    return uptoken;
//           // },
//           get_new_uptoken: false,             // 设置上传文件的时候是否每次都重新获取新的uptoken
//           // downtoken_url: '/downtoken',
//           // Ajax请求downToken的Url，私有空间时使用，JS-SDK将向该地址POST文件的key和domain，服务端返回的JSON必须包含url字段，url值为该文件的下载地址
//           // unique_names: true,              // 默认false，key为文件名。若开启该选项，JS-SDK会为每个文件自动生成key（文件名）
//           // save_key: true,                  // 默认false。若在服务端生成uptoken的上传策略中指定了sava_key，则开启，SDK在前端将不对key进行任何处理
//           domain: 'http://static.v1.wakooedu.com',     // bucket域名，下载资源时用到，必需
//           container: 'container',             // 上传区域DOM ID，默认是browser_button的父元素
//           max_file_size: '100mb',             // 最大文件体积限制
//           flash_swf_url: 'path/of/plupload/Moxie.swf',  // 引入flash，相对路径
//           max_retries: 3,                     // 上传失败最大重试次数
//           dragdrop: true,                     // 开启可拖曳上传
//           drop_element: 'container',          // 拖曳上传区域元素的ID，拖曳文件或文件夹后可触发上传
//           chunk_size: '4mb',                  // 分块上传时，每块的体积
//           auto_start: true,
//           resize: {
//             width: 400,
//             height: 400,
//             crop: false,
//             quality: 80,
//             preserve_headers: false
//           },

//           // 选择文件后自动上传，若关闭需要自己绑定事件触发上传
//           // x_vars : {
//           //    查看自定义变量
//           //    'time' : function(up,file) {
//           //        var time = (new Date()).getTime();
//           // do something with 'time'
//           //        return time;
//           //    },
//           //    'size' : function(up,file) {
//           //        var size = file.size;
//           // do something with 'size'
//           //        return size;
//           //    }
//           // },
//           init: {
//             'FilesAdded': function (up, files) {
//               plupload.each(files, function (file) {
//                 console.log('文件添加进队列后，处理相关的事情' + file);
//                 // 文件添加进队列后，处理相关的事情
//               });
//               Indicator.open({text: '上传中', spinnerType: 'fading-circle'});
//             },
//             'BeforeUpload': function (up, file) {
//               console.log(file);
//               // 每个文件上传前，处理相关的事情
//             },
//             'UploadProgress': function (up, file) {
//               // 每个文件上传时，处理相关的事情
//             },
//             'FileUploaded': function (up, file, info) {
// //              console.log('文件上传完成，处理相关的事情');
// //              console.log(info);
//               let params = {
//                 'user_id': _self.$store.state.userInfo.user.user_id,
//                 'json_data': info
//               };
//               netTool.passAvator(params)
//                 .then(response => {
//                   if (response.errno === '0') {
//                     console.log(response.result.avatar_url);
//                     _self.$store.commit({
//                       type: 'reIcon',
//                       icon: response.result.avatar_url
//                     });
//                     Indicator.open('上传成功');
//                     Indicator.close();
//                   } else {
//                     console.log(response.message);
//                   }
//                 })
//                 .catch(error => {
//                   console.log(error);
//                 });
//             },
//             'Error': function (up, err, errTip) {
//               Indicator.open('上传失败,请重新试试');
//               // 上传出错时，处理相关的事情
//             },
//             'UploadComplete': function () {
//               // 队列文件处理完毕后，处理相关的事情
//             },
//             'Key': function (up, file) {
//               // 若想在前端对每个文件的key进行个性化处理，可以配置该函数
//               // 该配置必须要在unique_names: false，save_key: false时才生效
//               var key = Date.parse(new Date());
//               // do something with key here
//               return key;
//             }
//           }
//         });
//       },
//       qiniuInitToken () {
//         PostMsg.getUpToken().then(response => {
//           if (response.errno === '0') {
//             this.uptoken = response.result.uptoken;
//             this.qiniuInit();
//           } else {
//             console.log('未获取到token');
//           }
//         }).catch(e => {
//           console.log(e);
//         });
//       }
    }
  };
</script>

<style scoped lang="scss" type="text/scss" rel="stylesheet/scss">
  @import '../assets/scss/base.scss';

  .header {
    position: relative;
    margin-left: px2rem(77);
    height: px2rem(250);
    font-size: px2rem(35.81);
  }

  /*.header:after{ display: block; clear:both; content: '';}*/
  .avator {
    /*float:left;*/
    width: px2rem(274);
    height: px2rem(274);
    display: inline-block;
    border-radius: 50%;

    .icon {
      margin: px2rem(6) px2rem(6) px2rem(6) px2rem(6);
      width: px2rem(262);
      height: px2rem(262);
      border: px2rem(5) solid white;
      border-radius: 50%;
      .avatar {
        width: px2rem(262);
        height: px2rem(262);
        border-radius: 50%;
      }

    }
  }

  .content {
    position: absolute;
    margin-left: px2rem(23);
    margin-top: px2rem(110);
    display: inline-block;
  }

  .setting {
    @include bg-img('../assets/img/common/Gear-icon');
    margin-bottom: px2rem(10);
    margin-left: px2rem(240);
    width: px2rem(40);
    height: px2rem(40);
  }

  .heart {
    @include bg-img('../assets/img/common/Color-Fill-33');
    vertical-align: top;
    display: inline-block;
    width: px2rem(50);
    height: px2rem(50);
  }

  .name {
    margin-left: px2rem(6);
    display: inline-block;
    height: px2rem(50);
    line-height: px2rem(50);
    font-size: px2rem(35);
    color: #a56a2c;
    font-weight: bold;
  }

  .other {
    margin-top: px2rem(9);
    font-size: px2rem(27);
    color: #a56a2c;
    font-weight: bold;
    text-align: center;
  }

</style>



// WEBPACK FOOTER //
// peopleHeader.vue?2e381d4e